import {Component, Input, OnInit} from "@angular/core";
import {ActivatedRoute, Router} from "@angular/router";
import {ResizeEvent} from "angular-resizable-element";
import {ToastrService} from "ngx-toastr";
import {ServiceLocation} from "../../../models/service-location";
import {ServiceLocationControllerService} from "../../../services/location-controller/service-location-controller.service";
import {ModalService} from "../../utils/base_modal.component";
import {TranslatedBaseError} from "../TranslatedBaseError";
import {TranslateService} from "@ngx-translate/core";
import {DeterminantControllerService} from "../../../services/registration-controller/determinant-controller.service";

@Component({
  selector: "service-location-table",
  templateUrl: "./service-location-table.component.html",
  providers: [ServiceLocationControllerService, ModalService],
  styles: [".cursor-hand {cursor: pointer;}"],
})
export class ServiceLocationTableComponent extends TranslatedBaseError implements OnInit {

  @Input() public hideList: boolean = false;
  public serviceId: string;
  public determinantMapById: { [key: string]: string } = {};

  public baseUrl: string;
  public serviceLocations: ServiceLocation[] = [];

  public style: object = {};
  public serviceLocation: ServiceLocation;
  public showEdit: boolean = false;
  public showAdd: boolean = false;
  public newCustomFilterBy: string;

  constructor(private route: ActivatedRoute,
              private serviceLocationControllerService: ServiceLocationControllerService,
              private determinantService: DeterminantControllerService,
              private router: Router,
              toastr: ToastrService,
              public translateService: TranslateService) {
    super(toastr, translateService);
  }

  public ngOnInit() {
    this.route.params.subscribe((params) => {
      this.serviceId = params.serviceId;
      this.baseUrl = "/services/" + this.serviceId + "/locationstable";
      this.getServiceDeterminantKeyName();
    });
    this.getServiceLocations(this.serviceId);
  }

  public getServiceDeterminantKeyName() {
    this.determinantService.getServiceDeterminantIdAndName(this.serviceId).subscribe(
      (data) => Object.assign(this.determinantMapById, data),
    );
  }

  public getServiceLocations(serviceId) {
    this.serviceLocationControllerService.getServiceLocations(serviceId).subscribe(
        (data) => {
          this.serviceLocations = data;
        },
        (error) => this.showErrorMessageWithTitle("Error HTTP Post Service!", error),
    );
  }

  public deleteServiceLocation(serviceLocation) {
    this.serviceLocationControllerService.deleteServiceLocation(serviceLocation.id).subscribe(
        (data) => {
          this.responseSuccessful("Location deleted!");
          this.ngOnInit();
          this.router.navigate(["/services/" + this.serviceId + "/locationstable"]);
        },
        (error) => {
          this.showErrorMessage(error != null && error.error != null ? JSON.parse(error.error) : error); },
    );
  }

  public updateServiceLocation(item) {
    return this.serviceLocationControllerService.saveServiceLocation(this.serviceId, item).subscribe(
      (data) => {
        item.isInRenameMode = false;
        item.isLoading = false;
        this.responseSuccessful("Location saved!");
      },
      (error) => {
        this.ngOnInit();
        return this.showErrorMessage(error);
      },
    );
  }

  public onNewFilterBy(value) {
    this.newCustomFilterBy = value;
  }
  public loadServiceLocation(serviceLocation) {
    if (serviceLocation) {
      this.serviceLocation = this.serviceLocations.find((it) => {
        return it.id === serviceLocation.id;
      });
      this.showEdit = true;
    } else {
      this.serviceLocation = new ServiceLocation();
      this.serviceLocation.name = this.newCustomFilterBy;
      this.showAdd = true;
    }
  }

  public onResizeEnd(event: ResizeEvent) {
    this.style = {
      width: `${event.rectangle.width}px`,
    };
  }

  public closeSlider() {
    this.getServiceLocations(this.serviceId);
    this.closeLayers();
  }

  public closeLayers() {
    this.showAdd = false;
    this.showEdit = false;
    this.style = {};
  }

}
